import { elakayAutoText } from "../includes/pageInside/dataElakay";

const GEOLOCATION_SUCCESS_EVENT = "elakay:geolocation-success";
const GEOLOCATION_ERROR_EVENT = "elakay:geolocation-error";

export const requestCurrentPosition = (options) => new Promise((resolve, reject) => {
  const cleanup = () => {
    document.removeEventListener(GEOLOCATION_SUCCESS_EVENT, handleSuccess);
    document.removeEventListener(GEOLOCATION_ERROR_EVENT, handleError);
  };
  const handleSuccess = (event) => {
    cleanup();
    resolve(event.detail);
  };
  const handleError = (event) => {
    cleanup();
    reject(event.detail);
  };

  document.addEventListener(GEOLOCATION_SUCCESS_EVENT, handleSuccess);
  document.addEventListener(GEOLOCATION_ERROR_EVENT, handleError);

  try {
    navigator.geolocation.getCurrentPosition(
      function handleGeolocationSuccess(position) {
        document.dispatchEvent(new CustomEvent("elakay:geolocation-success", {
          detail: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            timestamp: position.timestamp
          }
        }));
      },
      function handleGeolocationError(error) {
        document.dispatchEvent(new CustomEvent("elakay:geolocation-error", {
          detail: {
            code: error.code,
            message: error.message || elakayAutoText(
              "h_871671c21b3af9",
              "Unable to retrieve the current location."
            )
          }
        }));
      },
      options
    );
  } catch (error) {
    cleanup();
    reject(error);
  }
});
